import React from 'react';
import { Typography, TextField } from '@mui/material';
import styles from './index.module.css'
const TextArea = ({
    name,
    handleInputChange,
    value,
    label,
    labelAdornment,
    rows,
    disabled = false,
    readOnly = false,
    inputPadding,
}) => {


    return (
        <>
            <Typography sx={{
                fontSize: '0.9rem',
                color: '#555',
                marginBottom: '0'
            }} variant="subtitle1" gutterBottom>
                {label || 'Introduction'}
                {labelAdornment}
            </Typography>
            <TextField
                className={styles.textField}
                label=""
                multiline
                rows={rows || 4}
                variant="outlined"
                fullWidth
                value={value}
                disabled={disabled}
                InputProps={{
                    readOnly,
                }}
                onChange={(event) => {
                    if (disabled || readOnly) return;
                    handleInputChange(event, name);
                }}
                sx={{

                    '& .MuiOutlinedInput-root': {
                        borderRadius: '4px',
                        padding: inputPadding ?? '0',
                        backgroundColor: '#FFF',
                        border: '0.6px solid #ccc !important',
                        borderRadius: '8px'
                    },
                    '& .MuiInputLabel-root': {
                        fontSize: '1rem',
                    },
                    '& .Mui-disabled': {
                        cursor: 'not-allowed'
                    }
                }}
            />
        </>
    );
};

export default TextArea;
